import { EmailOutlined, Instagram, Phone, Twitter } from '@mui/icons-material'
import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

export default function Contact() {

    const contactSectionRef = useRef<HTMLDivElement>(null)
    const currentLocation = useLocation()

    useEffect(()=>{
        if(currentLocation.hash === "#contact-us"){
            contactSectionRef?.current?.scrollIntoView()
        }
    },[currentLocation.hash])

    return (
        <section ref={contactSectionRef} className='p-24 md:px-0 flex flex-col items-center bg-secondary2'>

            <div className='w-2/5 md:w-4/5 mb-10 md:mb-24'>
                <h5 className="text-3xl font-bold text-primary text-center">
                    Get in touch with us through
                </h5>
                {/* <p></p> */}
            </div>

            <div className="flex w-9/12 justify-between items-center flex-wrap md:text-center">

                <a href='/' className='flex md:inline-flex md:w-1/3 flex-col items-center justify-center  md:mr-1 mb-8'>

                    <div className="flex p-3 bg-primary rounded-full">
                        <Phone fontSize='medium' className='text-secondary' />
                    </div>
                    <p className='text-graphite mt-3'>+233 50 600 0705</p>
                    
                </a>
                <a href='mailto:customersupport@theshopkeeper.com' className='flex md:inline-flex md:w-1/3 flex-col items-center justify-center md:mr-1 mb-8'>

                    <div className="flex p-3 bg-primary rounded-full">
                        <EmailOutlined fontSize="medium" className='text-secondary' />
                    </div>
                    <p className='text-graphite mt-3'>
                        customersupport <br className='hidden md:block' /> @theshopkeeper.com
                    </p>
                    
                </a>
                <a href='https://twitter.com/theshopkeeper' className='flex md:inline-flex md:w-1/3 flex-col items-center justify-center md:mr-1 mb-8'>

                    <div className="flex p-3 bg-primary rounded-full">
                        <Twitter fontSize="medium" className='text-secondary' />
                    </div>
                    <p className='text-graphite mt-3'>@theshopkeeper</p>
                    
                </a>
                <a href='/' className='flex md:inline-flex md:w-1/3 flex-col items-center justify-center md:mr-1 mb-8'>

                    <div className="flex p-3 bg-primary rounded-full">
                        <Instagram fontSize="medium" className='text-secondary' />
                    </div>
                    <p className='text-graphite mt-3'>@theshopkeeper</p>
                    
                </a>

            </div>
            
        </section>
    )
}
